import coinIcon from '../assets/coin-icon.png'
import stripedDecoration from '../assets/striped_decoration.png'

interface MonthlyRevenueCardProps {
  amount: string
}

export function MonthlyRevenueCard(props: MonthlyRevenueCardProps) {
  return (
    <div className='relative mt-[34px] flex h-[112px] w-full flex-col justify-center rounded-[28px] bg-[#6e59cd] px-5 shadow-[0px_10px_20px_rgba(110,89,205,0.25)]'>
      <p
        className='font-semibold text-[16px] leading-normal text-[#FFF991] not-italic'
        data-testid='total-earnings-title'
      >
        This Month's Revenue
      </p>

      <div className='mt-[8px] flex items-center gap-[10px]'>
        <img alt='' className='size-[24px]' src={coinIcon} />
        <p
          className='font-black text-[24px] leading-normal text-white not-italic'
          data-testid='total-earnings-amount'
        >
          {props.amount}
        </p>
      </div>

      <div className='pointer-events-none absolute right-0 bottom-0'>
        <img
          alt=''
          src={stripedDecoration}
          className='h-[110px] w-auto rounded-[28px]'
          loading='lazy'
        />
      </div>
    </div>
  )
}
